import * as inspectionDetailActions from '../actions/inspectionDetail';

const defaultState = {
    inspection: null,
    inspectionSettings: null,
    visibleModal: null,
    token: null,
    isExporting: false,
    HHSRSScoring: null,
    hasStartedHHSRSScoring: false,
    isInspectionValidForHHSRSScoring: false,
};

export default function (state = defaultState, action) {
    switch (action.type) {
        case inspectionDetailActions.INSPECTION_REFRESHED:
            return {
                ...state,
                inspection: action.inspection,
            };
        case inspectionDetailActions.INSPECTION_SETTINGS_REFRESHED:
            return {
                ...state,
                inspectionSettings: action.inspectionSettings,
            };
        case inspectionDetailActions.HHSRS_SCORING_REFRESHED:
            return {
                ...state,
                HHSRSScoring: action.HHSRSScoring,
            };
        case inspectionDetailActions.HHSRS_SCORING_START_STATUS_REFRESHED:
            return {
                ...state,
                hasStartedHHSRSScoring: action.hasStartedHHSRSScoring,
            };
        case inspectionDetailActions.HHSRS_SCORING_VALIDATION_STATUS_REFRESHED:
            return {
                ...state,
                isInspectionValidForHHSRSScoring:
                    action.isInspectionValidForHHSRSScoring,
            };
        case inspectionDetailActions.VISIBLE_MODAL_TOGGLED:
            return {
                ...state,
                visibleModal: action.visibleModal,
            };
        case inspectionDetailActions.TOKEN_REFRESHED:
            return {
                ...state,
                token: action.token,
            };
        case inspectionDetailActions.IS_EXPORTING_REFRESHED:
            return {
                ...state,
                isExporting: action.isExporting,
            };
        case inspectionDetailActions.RESET:
            return defaultState;
        default:
            return state;
    }
}
